import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Avatar } from "../common";
import { UserBasicDetailsDto } from "../../types/dtos/generic";

interface CollabDocCollaboratorsProps {
  participants: UserBasicDetailsDto[];
}

function CollabDocCollaborators({ participants }: CollabDocCollaboratorsProps) {
  const { t } = useTranslation();

  return (
    <div className="hidden lg:flex items-center gap-2 print:flex">
      <span className="text-sm text-white/70 print:!text-gray-700">
        {t("Pages.CollaborativeDocument.Heading.Participants")}:
      </span>
      <div className="flex -space-x-1">
        {participants.map((participant, pix) => (
          <Avatar
            key={`p${pix}`}
            userFullName={participant.fullName}
            userInitials={participant.initials}
            size={8}
            imageUrl={
              participant.profileImageUrl
                ? participant.profileImageUrl
                : undefined
            }
          />
        ))}
      </div>
    </div>
  );
}

export default memo(CollabDocCollaborators);
